module.exports = __webpack_public_path__ + "img/brand_3.86328af4.png";